import { Text } from "@meditect/medibase-components";

export const UserPhoneNumberAlreadyExistsError = (): React.ReactElement => {
  return <Text>Ce numéro de téléphone est déjà utilisé par un autre utilisateur</Text>;
};
